import { Card, Col, Container, Row } from 'react-bootstrap';
import bg37 from 'assets/img/bg/37.png';
import authIllustrations from 'assets/img/spot-illustrations/auth-hva.png';
import authIllustrationsDark from 'assets/img/spot-illustrations/auth-hva.png';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import Logo2 from 'components/common/Logo2';

interface AuthCardLayoutProps {
  logo?: boolean;
  className?: string;
}

const AuthCardLayout = ({
  logo = true,
  children
}: PropsWithChildren<AuthCardLayoutProps>) => {
  return (
    <Container fluid className="bg-body-tertiary dark__bg-gray-1200">
      <div
        className="bg-holder bg-auth-card-overlay"
        style={{ backgroundImage: `url(${bg37})` }}
      />

      <Row className="flex-center position-relative min-vh-100 g-0 py-0">
        <Col xs={10} lg={8} xxl={6}>
          <Card className="border border-translucent auth-card">
            <Card.Body className="pe-md-0">
              <Row className="align-items-center gx-0 gy-0">
                <Col
                  xs="auto"
                  xl="auto"
                  className="position-relative overflow-hidden auth-title-box px-4 pe-0 pt-4 text-center"
                  style={{ width: '250px' }}
                >
                  <div className="d-none d-md-block text-center z-n1">
                    <img
                      className="auth-title-box-img d-dark-none"
                      src={authIllustrations}
                      alt=""
                    />
                    <img
                      className="auth-title-box-img d-light-none"
                      src={authIllustrationsDark}
                      alt=""
                    />
                  </div>
                </Col>
                <Col className="mx-4 me-4">
                  <p className="mb-0 text-body-tertiary fs-10 justify-content-end d-flex position-absolute bottom-0 end-0 p-3 pb-2">
                    v{import.meta.env.VITE_VERSION}
                  </p>
                  {logo && (
                    <div className="text-center">
                      <Link
                        to="#"
                        className="d-inline-block text-decoration-none mb-5"
                      >
                        <Logo2
                          width={160}
                          className="fw-bolder fs-5 d-inline-block mt-4"
                        />
                      </Link>
                    </div>
                  )}
                  <div className="auth-form-box">{children}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthCardLayout;
